import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {RfqDataService} from '../service/rfq.data.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-rfq-step-four',
    templateUrl: './step-four.component.html',
    styleUrls: ['../rfq.component.scss', '../rfq.blocks.scss']
})
export class StepFourComponent implements OnInit {

    @Input('event') event$: EventEmitter<boolean>;
    @ViewChild('stepFour', {static: false}) stepFourDivElement!: ElementRef<HTMLDivElement>;
    @ViewChild('navigation') navigation!: ElementRef<HTMLDivElement>;

    constructor(@Inject(DOCUMENT) public document: Document,
                public router: Router,
                public data: RfqDataService) {
    }

    ngOnInit(): void {
        this.event$?.subscribe((event: boolean): void => {
            this.data.steps[3].height
                = this.navigation.nativeElement.scrollHeight + this.stepFourDivElement.nativeElement.scrollHeight;
        });
    }
    
    close(): void {
        this.router.navigateByUrl('/home');
    }
}
